module.exports = __webpack_public_path__ + "static/metal-frame10-51c3a5adf6ad7ca592e77104dd3cac17.jpg";